import _map from 'lodash/map';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_INSTALLATION_DEVICES,
  GET_INSTALLATION_DEVICES_SUCCESS,
  GET_INSTALLATION_DEVICES_ERROR,
  ADD_INSTALLATION_DEVICE,
  ADD_INSTALLATION_DEVICE_SUCCESS,
  ADD_INSTALLATION_DEVICE_ERROR,
  DELETE_INSTALLATION_DEVICE,
  DELETE_INSTALLATION_DEVICE_SUCCESS,
  DELETE_INSTALLATION_DEVICE_ERROR,
  GET_INSTALLATION_DEVICE,
  GET_INSTALLATION_DEVICE_SUCCESS,
  GET_INSTALLATION_DEVICE_ERROR,
  UPDATE_INSTALLATION_DEVICE,
  UPDATE_INSTALLATION_DEVICE_SUCCESS,
  UPDATE_INSTALLATION_DEVICE_ERROR,
  REPLACE_INSTALLATION_DEVICE,
  REPLACE_INSTALLATION_DEVICE_SUCCESS,
  REPLACE_INSTALLATION_DEVICE_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/device';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.installationDevice;
const installationDevice = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullInstallation' || action.target === 'currentInstallation') {
        return {
          ...state,
          list: { ...initialSettings.list },
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
          replace: { ...initialSettings.replace },
        };
      }
      switch (action.target) {
        case 'addInstallationDevice':
          key = 'add';
          break;
        case 'listInstallationDevice':
          key = 'list';
          break;
        case 'replaceInstallationDevice':
          key = 'replace';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST DEVICES
    case GET_INSTALLATION_DEVICES:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: null,
        },
      };
    case GET_INSTALLATION_DEVICES_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case GET_INSTALLATION_DEVICES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: _map(action.data.data, (device) => ({ id: device.id, serial: device.serial })),
          loading: false,
        },
      };
    // ADD DEVICE
    case ADD_INSTALLATION_DEVICE:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          device: null,
          error: null,
        },
      };
    case ADD_INSTALLATION_DEVICE_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_INSTALLATION_DEVICE_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          device: deserialize(action.data.data),
          added: true,
        },
      };
    // DELETE DEVICE
    case DELETE_INSTALLATION_DEVICE:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case DELETE_INSTALLATION_DEVICE_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_INSTALLATION_DEVICE_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // GET DEVICE
    case GET_INSTALLATION_DEVICE:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_INSTALLATION_DEVICE_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_DEVICE_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // UPDATE DEVICE
    case UPDATE_INSTALLATION_DEVICE:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case UPDATE_INSTALLATION_DEVICE_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_INSTALLATION_DEVICE_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    // REPLACE DEVICE
    case REPLACE_INSTALLATION_DEVICE:
      return {
        ...state,
        replace: {
          ...state.replace,
          replaced: false,
          error: null,
        },
      };
    case REPLACE_INSTALLATION_DEVICE_ERROR:
      return {
        ...state,
        replace: {
          ...state.replace,
          error: action.error,
        },
      };
    case REPLACE_INSTALLATION_DEVICE_SUCCESS:
      return {
        ...state,
        replace: {
          ...state.replace,
          replaced: true,
        },
      };
    default:
      return state;
  }
};

export default installationDevice;



// WEBPACK FOOTER //
// ./reducers/installation/installationDevice.js